import React from "react";
import "./FloatIcons.css";
import Feedback from "../Feedback";
import mailData from "../../data/mailData.js";

function FloatIcons() {
  return (
    <>
      <div className="floatIconContainerA">
        <a
          href={`mailTo:${mailData.languageTrainings}`}
          className="floatIconA"
        >
          <img
            src="/images/FloatIcons/Contact-us-icon.png"
            alt="Mail-Icon"
            className="FloatIconMailIcon"
          />
          <p className="FloatIconName">Contact Us</p>
        </a>

        {/* <a href="" className="floatIconA">
          <img
            src="/images/homePage/feedback.png"
            alt="Mail-Icon"
            className="FloatIconMailIcon"
          />
          <p className="FloatIconName">Feedback</p>
        </a> */}
        <Feedback />
        <a
          href="https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxMzQ0NTY4NyJ9/new"
          className="floatIconA"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="/images/FloatIcons/viva-engage.png"
            alt="Yammer-Icon"
            className="FloatIconMailIcon"
          />
          <p className="FloatIconName">Viva Engage</p>
        </a>

        <a
          href="#"
          className="floatIconA"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="/images/FloatIcons/Newsletter.png"
            alt="Newsletter-Icon"
            className="FloatIconMailIcon"
          />
          <p className="FloatIconName">Newsletter</p>
        </a>

        <a
          href="#"
          className="floatIconA"
          target="_blank"
          rel="noreferrer"
          
        >
        {/* <img
            src="/images/FloatIcons/Newsletter.png"
            alt="Newsletter-Icon"
            className="FloatIconMailIcon"
          /> */}
        <p className="FloatIconName" style={{marginTop: '-5px'}}> Join our<br /> Language<br /> Clubs</p>
    </a >

      </div >
    </>
  );
}

export default FloatIcons;
